const getData = () => {
    return JSON.parse(JSON.stringify(window.myCV));
};

let myCV = getData();
let currentLang = 'fr';

const g_getAge = () => {
    const dateString = "1985-12-10";
    const birthday = new Date(dateString);
    const ageDifMs = Date.now() - birthday.getTime();
    const ageDate = new Date(ageDifMs); // milliseconds from epoch
    return Math.abs(ageDate.getFullYear() - 1970);
};

const init = () => {
    myCV.age = g_getAge() + ' ans';
    myCV.age_en = g_getAge() + ' years old';
    let nbMonths = Math.round((Date.now() - new Date("2019-02-01")) / 1000 / 86400 / 30);
    const nbYears = nbMonths > 12 ? parseInt(nbMonths / 12 + '', 10) : 0;
    nbMonths = nbMonths - nbYears * 12;
    myCV.employers[0].duration = nbYears >= 1 ?
        (nbYears + ' an' + (nbYears >= 2 ? 's' : '') + (nbMonths > 0 ? ' et ' + nbMonths + ' mois' : ''))
        : (nbMonths + ' mois');
    myCV.employers[0].duration_en = nbYears >= 1 ?
        (nbYears + ' year' + (nbYears >= 2 ? 's' : '') + (nbMonths > 0 ? ' and ' + nbMonths + ' m.' : ''))
        : (nbMonths + ' m.');
};
init();

export default class DataService {

    getAll() {
        return myCV;
    }

    getEmployers() {
        return myCV.employers;
    }

    getLinkInfo(key) {
        return myCV.links[key] || {};
    }

    getSkill(key) {
        return myCV.skills.find(x => x.name === key) || {};
    }


    getMiscs() {
        return myCV.miscs;
    }

    getTrainings() {
        return myCV.trainings
    }

    getPersonalStuffs() {
        return myCV.personalStuff
    }

    _changeLang(obj, lang) {
        for (let prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                const newObj = obj[prop];
                if (Array.isArray(newObj)
                    && newObj.filter(x => typeof x === 'string').length === 0) {
                    newObj.forEach(x => this._changeLang(x, lang));
                } else if (typeof newObj === 'object' && !Array.isArray(newObj)) {
                    this._changeLang(newObj, lang);
                } else {
                    if (obj[prop + '_' + lang]) {
                        if (!obj[prop + '_fr']) {
                            //
                            obj[prop + '_fr'] = obj[prop];
                        }
                        obj[prop] = obj[prop + '_' + lang];
                    }
                }
            }
        }
    }

    changeLang(lang) {
        if (!lang) {
            lang = currentLang === 'fr' ? 'en' : 'fr';
        }
        currentLang = lang;
        this._changeLang(myCV, lang);
    }
}
